import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { FormItem } from "azure-devops-ui/FormItem";
import { TextField, TextFieldWidth } from "azure-devops-ui/TextField";

const customObservable = new ObservableValue<string>("");

export default class CustomPrefixTextFieldExample extends React.Component<any, any> {
    public render(): JSX.Element {
        return (
            <FormItem label="Home page:">
                <TextField
                    prefixIconProps={{
                        render: className => <span className={className}>https://</span>
                    }}
                    value={customObservable}
                    onChange={(e, newValue) => (customObservable.value = newValue)}
                    width={TextFieldWidth.standard}
                />
            </FormItem>
        );
    }
}
